module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/big/1-2af6ef530696527ae964f937d4d8b090.webp";